import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Test", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_IonRow = _resolveComponent("IonRow")
  const _component_IonGrid = _resolveComponent("IonGrid")
  const _component_IonPage = _resolveComponent("IonPage")

  return (_openBlock(), _createBlock(_component_IonPage, null, {
    default: _withCtx(() => [
      _createVNode(_component_Header),
      _createVNode(_component_IonGrid, null, {
        default: _withCtx(() => [
          _createVNode(_component_IonRow, { class: "unite-spacer ion-justify-content-center ion-align-items-center" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}